import { inject, Injectable } from '@angular/core';
import { ApiService } from '@dev-fast/backend-services';
import type { IMotivatorDto } from '@dev-fast/types';
import { Socket } from 'ngx-socket-io';
import type { Observable } from 'rxjs';

import type {
  ICurrentLevelQuest,
  ILastDropData,
  ILevelQuestUserInfo,
  ILevelQuestUserLevel,
  ILevelQuestUserLevelUpdate,
  ILevelQuestUserUpdate,
  IQuestMotivator,
  ITakeReward,
} from '../types/backend';

@Injectable({
  providedIn: 'root',
})
export class AprilMadnessEventBackendService {
  readonly #apiService = inject(ApiService);
  readonly #socket = inject(Socket);

  getCurrentQuest(): Observable<ICurrentLevelQuest> {
    const url = `/api/leaders-race/level-quest/current`;
    return this.#apiService.get(url);
  }

  getUserQuestInfo(levelQuestId: number): Observable<ILevelQuestUserInfo> {
    const url = `/api/leaders-race/level-quest/user?levelQuestId=${levelQuestId}&userLevelsVisible=true`;
    const params = { withCredentials: true };
    return this.#apiService.get(url, params);
  }

  getLevelQuestMotivator(): Observable<IQuestMotivator> {
    const url = `/api/motivator/level-quest`;
    const params = { params: { limit: 6, keys: 'last' } };
    return this.#apiService.get(url, params);
  }

  collectLevelReward(levelQuestLevelId: number): Observable<ITakeReward | null> {
    const url = `/api/leaders-race/level-quest/user/level/take-reward`;
    const body = { levelQuestLevelId };
    const params = { withCredentials: true };
    return this.#apiService.post<ITakeReward>(url, body, params);
  }

  // РЎРѕРєРµС‚С‹

  userReceivingAnAwardEvent(): Observable<ILevelQuestUserLevel> {
    const socketName = 'leaders-race:level-quest-user-level:update';
    return this.#socket.fromEvent(socketName);
  }

  lastWonEvent(): Observable<IMotivatorDto<ILastDropData>> {
    const socketName = 'motivator.last.won';
    return this.#socket.fromEvent(socketName);
  }

  levelQuestUserUpdateEvent(): Observable<ILevelQuestUserUpdate> {
    const socketName = 'leaders-race:level-quest-user:update';
    return this.#socket.fromEvent(socketName);
  }

  levelQuestUserLevelUpdateEvent(): Observable<ILevelQuestUserLevelUpdate> {
    const socketName = 'leaders-race:level-quest-user-level:update';
    return this.#socket.fromEvent(socketName);
  }
}
